"use client";

import { useGallery, UseGalleryProps } from "./use-gallery";
import dynamic from "next/dynamic";

const GalleryImage = dynamic(() => import("./gallery-image"), {
  ssr: false,
});

export type GalleryProps = UseGalleryProps;

function Gallery(props: GalleryProps) {
  const {
    styles,
    data: { list },
    sectionName,
  } = useGallery(props);

  return (
    <section className={styles.base()} data-section-name={sectionName}>
      <div className={styles.wrapper()}>
        {list.map((item, index) => (
          <GalleryImage key={item.id} image={item.image} index={index} />
        ))}
      </div>
    </section>
  );
}

export default Gallery;
